import type { Segment } from "@busbud/int-schemas/udm/schemas";

export const getTripLegHasUnreliableDuration = (
  trip_segments: Pick<Segment<"v3">, "arrival_time">[]
) => {
  const last_segment = trip_segments[trip_segments.length - 1];
  // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return !last_segment.arrival_time?.timestamp;
};
